import React from "react";
import DatePicker from "material-ui/DatePicker";
import classNames from "classnames";
import DatePickerNew from "@techsoftware/happay-widgets/DatePicker";
import moment from "moment";
import "./dateStyle.css";
import i18n from "../i18nNext";

export default class CustomDate extends React.PureComponent {
    constructor(props) {
        super(props);
        this._dateIconClick = this._dateIconClick.bind(this);
        this._clearDate = this._clearDate.bind(this);
        this._onChange = this._onChange.bind(this);
    }

    _dateIconClick(event) {
        if (this.customDatePicker && !this.props.disabled) {
            this.customDatePicker.focus();
        }
    }

    _onChange(event, value) {
        if (this.props.onChange) {
            this.props.onChange(null, value);
        }
    }

    _clearDate(event) {
        event.preventDefault();
        if (this.props.onChange && !this.props.disabled) this.props.onChange(null, null);
    }

    render() {
        const {
            ref,
            isClearable,
            disabled,
            value,
            isRequired,
            autoOk,
            floatingLabelText,
            errorText,
            removeMargin,
            placeholder,
            fromFilter
        } = this.props;
        const idObj = { id: this.props.id };
        const val = JSON.stringify(this.props.value || {});
        const { formatDate = "YYYY-MM-DD", required, search, hideUnderline } = this.props;
        let cursor = disabled ? "no-drop" : "pointer";
        if (this.props.isWidgetComp) {
            const wrapperClass = `${removeMargin ? "" : "hw-customTextInput-wrapper"} ${this.props
                .parentWrapperClass || ""}`;
            return (
                <DatePickerNew
                    id={this.props.id || "newDatePicker"}
                    ref={ref || "datepickerRef"}
                    // isClearable={isClearable}
                    placeholder={placeholder ? placeholder : "e.g. DD/MM/YYYY"}
                    disabled={disabled}
                    value={value instanceof Date ? value : null}
                    required={required || isRequired}
                    onChange={this.props.onChange}
                    floatingLabelText={floatingLabelText}
                    autoOk={autoOk}
                    errorText={errorText}
                    fromdate={this.props.minDate}
                    todate={this.props.maxDate}
                    isEditable={fromFilter ? false : true}
                    parentWrapperClass={wrapperClass}
                    borderType={"light"}
                    openInModal
                    {...this.props}
                />
            );
        }
        return (
            <div {...idObj} style={{ position: "relative" }}>
                <DatePicker
                    {...this.props}
                    ref={input => (this.customDatePicker = input)}
                    className={classNames("date", { "hide-underline": hideUnderline })}
                    errorStyle={{ fontSize: "10px" }}
                    value={this.props.value || null}
                    onChange={this._onChange}
                    floatingLabelStyle={{ fontWeight: "normal", fontSize: 16 }}
                    textFieldStyle={Object.assign(
                        {
                            width: "100%",
                            fontSize: 12,
                            color: "#3c424e",
                            // fontFamily: "Roboto-Regular"
                            fontWeight: 400
                        },
                        this.props.textFieldStyle
                    )}
                    DateTimeFormat={Intl.DateTimeFormat}
                    formatDate={date => moment(date).format(formatDate)}
                    locale={i18n.language}
                    okLabel={i18n.t("btn.ok")}
                    cancelLabel={i18n.t("btn.cancel")}
                    dialogContainerStyle={{ zIndex: 2000 }}
                />
                {required || val === "{}" ? (
                    <img
                        onClick={this._dateIconClick}
                        style={Object.assign(
                            {
                                position: "absolute",
                                cursor: "pointer",
                                bottom: "12px",
                                right: "4px"
                            },
                            this.props.iconStyle
                        )}
                        src="/assets/images/calender_icon.svg"
                        height="15"
                        width="15"
                    />
                ) : (
                    !required && (
                        <img
                            onClick={this._clearDate}
                            style={Object.assign(
                                {
                                    position: "absolute",
                                    cursor: cursor,
                                    bottom: "15px",
                                    right: "4px",
                                    width: "10px"
                                },
                                this.props.iconStyle
                            )}
                            src="/assets/images/date-clear-icon.svg"
                        />
                    )
                )}
            </div>
        );
    }
}
